// English → Tamil / Malayalam transliteration via Google Input
// Tools' public endpoint. Degrades to the typed Latin text when
// unreachable. Pure logic — the caller wires it to a textarea.

export const TRANSLIT_ITC: Record<string, string> = {
  ta: "ta-t-i0-und",
  ml: "ml-t-i0-und",
};

const cache = new Map<string, string>();

export async function transliterateWord(word: string, itc: string): Promise<string> {
  const key = `${itc}:${word.toLowerCase()}`;
  const hit = cache.get(key);
  if (hit !== undefined) return hit;
  try {
    const res = await fetch(
      `https://inputtools.google.com/request?itc=${itc}&num=1&text=${encodeURIComponent(word)}`
    );
    const data = await res.json();
    const out: string = data[0] === "SUCCESS" ? data[1][0][1][0] : word;
    cache.set(key, out);
    return out;
  } catch {
    return word;
  }
}

/** A Latin word just finished at the end of `text` (space/punctuation typed). */
export const finishedWord = (text: string): RegExpMatchArray | null =>
  text.match(/([A-Za-z']+)([ \n.,!?…]+)$/);

/** A trailing half-finished Latin word (for flushing before save). */
export const trailingWord = (text: string): RegExpMatchArray | null =>
  text.match(/([A-Za-z']+)$/);
